import React from "react";
import { useLocation } from "react-router-dom";
import BusinessHubHeader from "../components/BusinessHubHeader.js";
import BusinessHubNavigation from "../components/BusinessHubNavigation.js";
import PromotionsAndMarketing from "../components/PromotionsAndMarketing.js";
import ActivePromotion from "../components/ActivePromotion.js";
import FeaturedPlacement from "../components/FeaturedPlacement.js";
import "../styles/UserManagmentPage.css";
import "../styles/PromotionsAndMarketing.css";

function PromotionsAndMarketingPage() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const view = searchParams.get("view");

  if (view === "promotion-details") {
    return <ActivePromotion />;
  }

  if (view === "featured-placement") {
    return <FeaturedPlacement />;
  }

  return (
    <div className="business-hub-screen">
      <div className="business-hub-header-container">
        <BusinessHubHeader />
      </div>

      <div className="business-hub-page-content-container">
        <div className="business-hub-navigation-sidebar">
          <BusinessHubNavigation mode="prod" active="H" onSelect={() => {}} />
        </div>

        <div className="business-hub-content-container">
          <div className="content-container">
            <PromotionsAndMarketing />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PromotionsAndMarketingPage;
